import React from 'react';

// CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './globals.scss';

// React i18n
import './i18n';

import ReactGA from 'react-ga';

// React Router Imports
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Redux Imports
import { Provider } from 'react-redux';
import { store } from './redux/store';

// Pages & Page Elements
import Layout from './UI/pages/layout/Layout';
import CancelSubscription from './UI/pages/subscription-cancellation/CancelSubscription';
import ReferralsPage from './UI/pages/referrals/ReferralsPage';
import UpdateShippingDatePage from './UI/pages/update-shipping-date/UpdateShippingDate';

const ga4reactId = process.env.REACT_APP_GOOGLE_ANALYTICS || '';
ReactGA.initialize(ga4reactId);
ReactGA.pageview(window.location.pathname + window.location.search);

const container = document.getElementById('root');
const root = createRoot(container!);
const region = process.env.REACT_APP_REGION;
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path='/referrals' element={<ReferralsPage />} />
          <Route path='/update-shipping-date' element={<UpdateShippingDatePage />} />
          {region === 'eu' && (
            <Route
              path='/cancel-subscription'
              element={<CancelSubscription />}
            />
          )}
        </Route>
        <Route path='*' element={<Navigate to='/referrals' replace />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
